<div class="wrapper">
  <div class="header">
    <div class="title">Snooze {{ selectedOrders?.length >= 2 ? 'orders' : 'order' }}</div>
    <pdq-button class="close" icon="close" variant="ghost" (onClick)="close()"></pdq-button>
  </div>
  <div class="content">
    <div>
      <div class="text">When would you like this order to return to the Ready tab?</div>
      <div class="snooze-options">
        <div class="snooze-option" (click)="scheduleOrders()">
          @if (isLoading) {
            <pdq-spinner></pdq-spinner>
          } @else {
            <img src="/assets/icons/sun.svg" />
          }
          <div class="text">Last time snoozed</div>
          <div class="date">{{ lastTimeSnoozed | date: 'MMM dd, hh:mmaaaa' }}</div>
        </div>
        <div class="snooze-option" (click)="openCalendar()">
          <img src="/assets/icons/calendar-1.svg" />
          <div class="text">Pick day and time</div>
        </div>
      </div>
    </div>
  </div>
</div>
